import { ServiceLocator } from '../../app/ServiceLocator';
import { Formatters, Messages } from '../../codegen/Localize';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { FlowContentType } from '../models/ContentTypes';
import { FlowBaseInfo } from '../models/FlowInfo';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { Set } from '../models/Set';
import { Flows } from '../resources/Flows';
import { IChangeContentTagsResult } from '../ServerApi/types/IChangeContentTagsAction';
import { ChangeTagsActionHelperService } from './ChangeTagsActionHelper';
import { ContentUrlForItem } from './ContentUrl';
import {
  IErrorDetail
} from '../../commonInfra/contentActions/ActionMessages';
import {
  standardActionErrorMsg,
  standardActionSuccessMsg,
  StandardActionToastMessages,
} from '../../commonInfra/contentActions/ActionHelpers';

export namespace ChangeFlowsTagsAction {

  const notificationTranslationFns: StandardActionToastMessages = {
    success: standardActionSuccessMsg(Messages.changeTagsFlowsSuccess),
    error: standardActionErrorMsg(Messages.changeTagsFlowsError),
  };

  export function execute(itemSet: Set<FlowBaseInfo>, actionContext: IActionContext): ng.IPromise<IChangeContentTagsResult> {
    return changeTagsService().createExecuteFn<FlowBaseInfo>({
      changeTagsAction: (ids: string[], addTags: string[], removeTags: string[]) => Flows.changeTags(ids, addTags, removeTags),
      getDescription: (flows: Set<FlowBaseInfo>) => getDescription(flows),
      notificationFns: notificationTranslationFns,
      errorDetailFn: (errorItem: IErrorItem<FlowBaseInfo>) => changeTagsErrorDetail(errorItem)
    })(itemSet, actionContext);
  }

  function getDescription(flows: Set<FlowBaseInfo>) {
    return (flows.size() === 1)
      ? Messages.changeTagsFlowDescription({ NAME: L10n.elideIfLong(flows.first().name) })
      : Messages.changeTagsFlowsDescription({ COUNT_LOC: Formatters.formatCount(flows.size()) });
  }

  function changeTagsErrorDetail(errorItem: IErrorItem<FlowBaseInfo>): IErrorDetail {
    return {
      itemName: errorItem.item.name,
      itemUrl: ContentUrlForItem(errorItem.item, FlowContentType),
      errorMessage:  changeTagsService().errorMessageFor(errorItem)
    };
  }
  const changeTagsService = () => ServiceLocator.get<ChangeTagsActionHelperService>('ChangeTagsActionHelperService');
}
